// import mock from './mock.js'
import Vue from 'vue'
import axios from 'axios'
import APIS from './apis.js'
// router
import router from './router.js'
import flexible from 'lib-flexible'
// 移动端适配

import store from './store.js'

Vue.mixin({
	data() {
		return {
			isFirstShare: true,
			qrCodeMask: false,
		}
	},
	methods: {
		authorize(url) {
			axios.get('/authorize', {
				url: encodeURIComponent(url)
			})
		},
		isOwnEmpty(obj) {
			for (var name in obj) {
				if (obj.hasOwnProperty(name)) {
					return false;
				}
			}
			return true;
		},
		getObjLength(obj) {
			var length = 0;
			for (var name in obj) {
				if (obj.hasOwnProperty(name)) {
					length++
				}
			}
			return length;
		},
		oneQrcode() {
			this.$data.qrCodeMask = !this.$data.qrCodeMask;
			this.$data.isFirstShare = false;
		},
		GetQueryString(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]); return null;
		}
	}
})
import { mapState } from 'vuex';

const app = new Vue({
	store,
	router,
	computed: mapState([
		'channel_id'
	]),
	created() {
		const that = this;
		if (that.$route.query.channel_id) {
			that.setChannelId(that.$route.query.channel_id)
		}
		if (that.GetQueryString("channel_id")) {
			that.setChannelId(that.GetQueryString("channel_id"));
		}
		that.getWxConfig(that.channel_id)
	},
	watch: {
		'channel_id': function(newVal) {
			this.getWxConfig(newVal)
		}
	},
	methods: {
		getWxConfig(channelId) {
			const that = this;
			axios.get(APIS.wechatData, {
				params: {
					url: location.href.split('#')[0],
					channelId: channelId,
				}
			}).then(function (res) {
				let data = res.data.data;
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，公众号的唯一标识
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature,// 必填，签名，见附录1
					jsApiList: [
						'onMenuShareTimeline',
						'onMenuShareAppMessage',
						'hideMenuItems',
						'showMenuItems'
					] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
				});

				wx.ready(function () {
					wx.hideMenuItems({
						menuList: [
							'menuItem:share:qq',
							'menuItem:share:weiboApp',
							'menuItem:share:QZone',
							"menuItem:openWithSafari",
							"menuItem:copyUrl"
						] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
					});
				});

				wx.error(function (res) {
					alert(res);
				})
			}).catch(function (error) {
				console.log(error);
			})
		}
	}
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js